import { handleActions } from 'redux-actions'
import {
  FETCH_TEMPLATES_DATA_INIT,
  FETCH_TEMPLATES_DATA_DONE,
  FETCH_TEMPLATES_DATA_FAIL,
  FETCH_TEMPLATE_CONFIGURATIONS_DONE,
} from '../actions/actions'
import $ from 'jquery'
import _ from 'underscore'

const templatesData = handleActions(
  {
    [FETCH_TEMPLATES_DATA_INIT]: (state, action) => {
      return {
        ...state,
        fetching: true,
        fetchedOnce: false,
      }
    },
    [FETCH_TEMPLATES_DATA_DONE]: (state, action) => {
      const {
        all_templates,
        filetype_templates_mapping: filetypeTemplatesMapping,
      } = action.payload
      let templates = $.extend(true, [], all_templates)
      _.map(all_templates, (template, index) => {
        templates[index]['label'] = template['name']
        templates[index]['value'] = template['id']
      })
      return {
        ...state,
        fetching: false,
        data: templates,
        fetchedOnce: true,
        filetypeTemplatesMapping,
      }
    },
    [FETCH_TEMPLATES_DATA_FAIL]: (state, action) => {
      return {
        ...state,
        fetching: false,
        fetchedOnce: false,
      }
    },

    [FETCH_TEMPLATE_CONFIGURATIONS_DONE]: (state, action) => {
      return {
        ...state,
        templateConfigurations: action.payload || {},
      }
    },
  },
  {
    fetching: false,
    data: null,
    fetchedOnce: false,
    filetypeTemplatesMapping: null,
    templateConfigurations: {},
  }
)

export default templatesData
